const confetti = require("@assets/js/confetti.js");
import vailcode from "@utils/errcode";
export default {
  name: "nftdetail",
  data() {
    return {
      animateStart: false,
      animateEle: false,
      showEle: false,
      isNftUrlLLoad: false,
      detail: null
    };
  },
  computed: {
    confetti() {
      return confetti;
    }
  },
  methods: {
    async getNftDetail(id) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/my/nftinfo", {
          id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.detail = {
            ...data,
            type: this.$route.query.type > 0 ? "compose" : null
          };
          console.log("this.detail", this.$route.query.type, this.detail);
          this.$router.replace({
            path: this.$route.path,
            query: {
              id: this.$route.query.id,
              type: "0" // 或其他你希望替换的值
            }
          });

          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    setConfetti() {
      this.confetti({
        particleCount: 20,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        }
      });
      this.confetti({
        particleCount: 20,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        }
      });
    },
    resetAnimation() {
      // Reset states and wait for image load
      this.animateStart = false;
      this.animateEle = false;
      this.showEle = false;
      this.isNftUrlLLoad = false;
    },
    async onImageLoad() {
      if (this.detail.type != "compose") {
        this.$parent.iscraftLoading = false;
        return;
      }
      this.isNftUrlLLoad = true;
      // Step 1: 播放 image 动画
      this.animateStart = true;
      await new Promise(resolve => setTimeout(resolve, 1500));
      // Step 2: 延迟显示元素部分
      this.showEle = true;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.setConfetti();
      this.animateEle = true;
      // this.$parent.iscraftLoading = false;
      // this.$parent.myNFTList.unshift(this.detail);
    },

    onImageError(err) {
      console.log("errrrrrrrrr", err);
    }
  },
  async mounted() {
    console.log("this.$route.query?.nft", this.$route.query?.nft);
    if (this.$route.query?.nft) {
      const obj = JSON.parse(decodeURIComponent(this.$route.query?.nft));
      this.detail = obj;
    } else if (this.$route.query?.id) {
      await this.getNftDetail(this.$route.query?.id);
    }
  }
};